import { Box, Heading, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { NormalizedWrapper, theme } from '@theme'

export const Wrapper = styled(Box)`
  background-color: ${theme.newColors.lightGray};
  min-height: 709px;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${({ theme }) => css`
    ${theme.below.laptop`
        height: 1000px;
    `}

    ${theme.below.tabletS`
      height: 1050px;
    `}

    ${theme.below.mobileXL`
        height: 900px;
    `}
  `}
`

export const BackgroundImage = styled(ImageWithPlaceholder)`
  height: 100%;
  inset: 0;
  object-fit: cover;
  position: absolute;
  width: 100%;
`

export const WrapperImage = styled(Box)`
  bottom: 0;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  right: 0;
  z-index: 1;
`

export const TextWrapper = styled(NormalizedWrapper)`
  position: relative;
  z-index: 2;

  ${({ theme }) => css`
    margin-top: 140px;

    ${theme.below.laptop`
      margin-top: ${theme.newSpaces.xl3}px;
    `}

    ${theme.below.tablet`
      margin-top: ${theme.newSpaces.xl3}px;
      margin-bottom: ${theme.newSpaces.xs}px;
      align-items: flex-start;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.sm}px;
      margin-top: ${theme.newSpaces.xl5}px;
    `}
  `}
`

export const Title = styled(Heading)`
  font-size: 60px;
  line-height: 90px;
  max-width: 666px;
  text-transform: uppercase;
  z-index: 5;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'blog')};

    color: ${theme.newColors.lightOrange};

    ${theme.below.laptop`
      margin-left: 0px;
    `}

    ${theme.below.mobileXL`
      font-size: 36px;
      line-height: 48px;
      max-width: 100%;
    `}

    ${theme.below.mobileM`
      ${theme.getTypography('mobile', 'title', 'blog')}
    `}

    ${theme.below.mobileS`
      ${theme.getTypography('mobile', 'title', 'title1')}
    `}
  `}
`

export const SubTitle = styled(Paragraph)`
  max-width: 527px;
  top: 60%;
  z-index: 5;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title4')};

    color: ${theme.newColors.lightOrange};
    margin-top: ${theme.newSpaces.sm}px;

    ${theme.below.laptop`
      margin-left: 0px;
    `}

    ${theme.below.tabletS`
      ${theme.getTypography('desktop', 'body', 'body1')};
    `}
  `}
`
